<template>
  <nav
    role="navigation"
    aria-label="search facet navigation"
  >
    <div class="navbar-brand">
      <a class="navbar-item" v-for="facet in facets" :key="facet.name">
        <div class="dropdown is-hoverable">
          <div class="dropdown-trigger">
            <button class="button">
              <span>{{ facet.name }}</span>
              <span class="icon is-small">
                <fa icon="angle-down"></fa>
              </span>
            </button>
          </div>
          <div class="dropdown-menu">
            <div
              class="dropdown-content is-small"
              v-if="facet.type === 'array' || facet.type === 'string'"
            >
              <FacetFilter :attribute="facet.key"></FacetFilter>
            </div>
            <div class="dropdown-content is-small" v-if="facet.type === 'tree'">
              <ais-tree-menu
                :attributes="[facet.key + '.lvl0', facet.key + '.lvl1']"
                :class-names="{
                  'ais-tree-menu': 'menu-list',
                  'ais-tree-menu__count': 'tag is-pulled-right',
                  'ais-tree-menu__item--active': 'has-text-weight-bold',
                  'ais-tree-menu__item': 'has-text-weight-normal',
                }"
              ></ais-tree-menu>
            </div>
          </div>
        </div>
      </a>
    </div>
  </nav>
</template>

<script>
import FacetFilter from '@/components/FacetFilter.vue';
import { Component } from 'vue-instantsearch';

export default {
  mixins: [Component],
  components: {
    FacetFilter,
  },
  computed: {
    facetValues(attribute) {
      return this.searchStore.getFacetValues(attribute);
    },
    show(attribute) {
      return this.facetValues(attribute).length > 0;
    },
    facets() { return this.$store.getters.facets(this.$route.params.directory); },
  },
};
</script>
